module.exports = __webpack_public_path__ + "img/MDI-eye.8fbfa258.svg";